import { Buffer } from 'buffer';
(globalThis as any).Buffer = Buffer;
(globalThis as any).global = globalThis;
import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { App } from './app/app';
import { Amplify } from 'aws-amplify';
import { environment } from './environments/environment';
Amplify.configure({
  API: {
    GraphQL: {
      endpoint: environment.appSync.endpoint,
      region: environment.appSync.region,
      defaultAuthMode: 'oidc',
    },
  },
});

bootstrapApplication(App, appConfig).catch((err) => console.error(err));
